import { Space } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { User } from 'api/models';
import { Avatar } from 'components/atoms/avatar';
import { Rate } from 'components/atoms/rate';
import { ClassNameOnlyProps } from 'components/ozone-component';
import { fullName } from 'utils/full-name';

interface ResponseListItemProps extends ClassNameOnlyProps {
  user: User;
  rating: number;
  comment?: string;
}

export const ResponseListItem: FC<ResponseListItemProps> = ({
  className,
  user,
  rating,
  comment,
}) => (
  <Space direction="vertical" className={className}>
    <Space align="center">
      <Avatar size="small" name={fullName(user)} src={user.photoUrl} />
      <Rate count={5} value={rating} disabled />
    </Space>
    <strong>
      <FormattedMessage id={`csat.rating.${rating}`} />
    </strong>
    <div>{comment}</div>
  </Space>
);
